import { FilledCheckIcon, RadioButtonThick } from '@va/icons';

export const DataPrivacyCardRadioButton = ({ selected }: { selected: boolean }) => {
  if (selected) {
    return <FilledCheckIcon className={'absolute top-18px right-18px w-18px h-18px'} />;
  }

  return <RadioButtonThick className={'absolute top-18px right-18px w-18px h-18px'} innerCircleColor={'transparent'} />;
};
